export * from './step4a-consent-proctoring-modal.component';
